var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoConvergencia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#F57E10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35857 9.156C8.20797 9.156 5.44754 7.484 4.21116 6.648L3.15139 8.548L6.78486 12.424L3 16.072L4.13546 18.124C5.58884 16.908 7.92032 15.768 9.13147 15.768C9.13147 17.0448 7.54183 19.644 6.70916 20.86L8.75299 21.848L12.4622 18.124L16.1713 22L18.0637 21.012C17.004 19.644 15.8685 17.212 15.7928 15.768C16.8223 15.8288 19.6534 17.4653 20.9402 18.276L21.8486 16.376L18.2151 12.652L22 8.928L21.0159 6.952C19.7442 7.9248 17.2311 9.232 15.8685 9.308C15.8685 8.472 17.0797 5.736 18.3665 4.14L16.4741 3.152L12.6135 6.8L8.90438 3L7.08765 3.988C7.54183 4.596 8.98008 7.18 9.35857 9.156Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConvergencia);
export default __webpack_public_path__ + "static/media/logo_convergencia.3bb98105.svg";
export { ForwardRef as ReactComponent };